// src/pages/admin/UsersList.js
import React, { useEffect, useState } from 'react';
import { Card, List, Avatar, Button, Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const UsersList = ({ users, handleDeleteUser, navigate }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle window resize to dynamically adjust layout
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Ensure users is an array and handle edge case
  if (!Array.isArray(users) || users.length === 0) {
    return (
      <Card title="Recent Users" bordered={false}>
        <p>No users available.</p>
      </Card>
    );
  }

  return (
    <Card
      title="Recent Users"
      bordered={false}
      style={{ marginBottom: 16 }}
    >
      <List
        itemLayout={isMobile ? 'vertical' : 'horizontal'}
        dataSource={users.slice(0, 5)} // Limit to 5 users as per original
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                type="link"
                onClick={() => navigate(`/admin/users/edit/${item.id}`)}
                key={`edit-${item.id}`}
              >
                Edit
              </Button>,
              <Button
                type="link"
                danger
                onClick={() => handleDeleteUser(item.id)}
                key={`delete-${item.id}`}
              >
                Delete
              </Button>,
            ]}
          >
            <List.Item.Meta
              avatar={<Avatar icon={<UserOutlined />} />}
              title={item.name || 'Unnamed User'} // Fallback for missing name
              description={
                <Space direction="vertical" size={0}>
                  <span>Role: {item.role || 'N/A'}</span>
                  <span>Status: {item.status || 'N/A'}</span>
                  <span>Email: {item.email || 'N/A'}</span>
                </Space>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
};

export default UsersList;